module.exports = __webpack_public_path__ + "img/ty_2.5249abbe.png";